import {
  Edit,
  SimpleForm,
  TextInput,
  Toolbar,
  SaveButton,
  useRecordContext,
  useTranslate,
} from 'react-admin';
import { Box, Typography, Avatar, Grid } from '@mui/material';
import type { Contact } from '../../types/chat.types';
import { PhoneInputWithCountry } from '../../components';

const ContactEditToolbar = () => (
  <Toolbar>
    <SaveButton />
  </Toolbar>
);

const ContactEditHeader = () => {
  const record = useRecordContext<Contact>();
  const translate = useTranslate();
  if (!record) return null;

  const name = record.name || translate('resources.contact.unknown');

  return (
    <Box display="flex" alignItems="center" gap={2} mb={2}>
      <Avatar sx={{ width: 48, height: 48 }}>
        {record.name?.[0]?.toUpperCase() || '?'}
      </Avatar>
      <Typography variant="h6">
        {translate('resources.contact.edit.title', { name })}
      </Typography>
    </Box>
  );
};

export const ContactEdit = () => {
  const translate = useTranslate();

  return (
    <Edit>
      <SimpleForm toolbar={<ContactEditToolbar />}>
        <ContactEditHeader />

        <Grid container spacing={2}>
          <Grid size={{ xs: 12, md: 6 }}>
            <TextInput source="name" label={translate('resources.contact.fields.name')} fullWidth />
          </Grid>

          <Grid size={{ xs: 12, md: 6 }}>
            <TextInput source="email" label={translate('resources.contact.fields.email')} type="email" fullWidth />
          </Grid>

          <Grid size={{ xs: 12, md: 6 }}>
            <PhoneInputWithCountry source="phoneNumber" label={translate('resources.contact.fields.phoneNumber')} fullWidth defaultCountry="BR" />
          </Grid>
        </Grid>
      </SimpleForm>
    </Edit>
  );
};
